export default {
  namespaced: true,
  state: {
    active: false,
  },
  getters: {
    status: state => state.active,
  },
  mutations: {
    mutateSpinner(state, data) {
      state.active = data;
    },
  },
  actions: {
    setSpinner(context, data) {
      context.commit('mutateSpinner', data);
    },
  },
};
